export default "__VITE_ASSET__DnmHOnFy__"